export const supportedTimezones = [
	{ value: "America/St_Johns", label: "Newfoundland Time (NST)" },
	{ value: "America/Halifax", label: "Atlantic Time (AST)" },
	{ value: "America/New_York", label: "Eastern Time (EST)" },
	{ value: "America/Chicago", label: "Central Time (CST)" },
	{ value: "America/Denver", label: "Mountain Time (MST)" },
	{ value: "America/Phoenix", label: "Mountain Time (no DST - Phoenix)" },
	{ value: "America/Los_Angeles", label: "Pacific Time (PST)" },
	{ value: "America/Anchorage", label: "Alaska Time (AKST)" },
	{ value: "Pacific/Honolulu", label: "Hawaii Time (HST)" },
	{ value: "America/Tijuana", label: "Pacific Time (Mexico - Tijuana)" },
	{ value: "America/Mazatlan", label: "Mountain Time (Mexico - Mazatlan)" },
	{ value: "America/Mexico_City", label: "Central Time (Mexico - Mexico City)" },
	{ value: "America/Cancun", label: "Eastern Time (Mexico - Cancun)" },
];
